import { createActionGroup, emptyProps } from '@ngrx/store';

export const customerPageActions = createActionGroup({
  source: 'CustomerPage',
  events: {
    jobStatisticsTabOpened: emptyProps(),
  },
});
